import React from "react";
import SearchForm from "../common/SearchForm";

interface AssignmentSearchProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  onSearch: (e: React.FormEvent) => void;
  onClearSearch?: () => void;
  placeholder: string;
  hasSearched?: boolean;
  searchLoading?: boolean;
}

// The search row of an assignment modal: SearchForm plus the panel's own
// padded, divided header.
const AssignmentSearch: React.FC<AssignmentSearchProps> = ({
  searchTerm,
  onSearchChange,
  onSearch,
  onClearSearch,
  placeholder,
  hasSearched = false,
  searchLoading = false,
}) => (
  <div className="border-b border-gray-200 p-6 dark:border-gray-800">
    <SearchForm
      value={searchTerm}
      onChange={onSearchChange}
      onSubmit={onSearch}
      onClear={onClearSearch}
      placeholder={placeholder}
      hasSearched={hasSearched}
      loading={searchLoading}
      variant="block"
      showResultsLine
    />
  </div>
);

export default AssignmentSearch;
